// extracted by mini-css-extract-plugin
export default {"button":"Button_button__XPSEf","button_danger":"Button_button_danger__emoUf","button_icon":"Button_button_icon__3BU7n"};